import { AxiosResponse } from 'axios'
import { NestAPI } from '../../nestapi'
import {
  BusinessManagerService,
  FacebookAssetNames,
  FBBusiness,
  FBBusinessAdAccount,
  FBBusinessIGAccount,
  FBBusinessPage,
  SystemUserIDs,
} from './BusinessManager.types'
import {
  Business,
  BusinessConfig,
  BusinessError,
  BusinessFBObjects,
  FacebookPixel,
  FBConnectedInstagramAccount,
  MatchRate,
} from '@marketing-milk/interfaces'
import { MMFacebookVerificationFields } from 'pages/business/accounts/builder/pages/edit/info/tabs/social/facebook'

export class BusinessManagerServiceImplementation implements BusinessManagerService {
  getInstagramPagesByAccountID(fbAccountID: string): Promise<FBConnectedInstagramAccount[]> {
    return NestAPI.get(`fb-accounts/instagram`, {
      params: {
        fbAccountID,
      },
    })
  }

  async createBusiness(businessConfig: BusinessConfig): Promise<Business> {
    const response: Business = await NestAPI.post(`businesses/manage`, businessConfig)
    return response
  }

  async updateBusiness(businessID: number, businessConfig: BusinessConfig): Promise<Business> {
    const response: Business = await NestAPI.patch(
      `businesses/manage/${businessID}`,
      businessConfig
    )
    return response
  }

  async getHistoricalMatchRate(businessID: number, eventType: string): Promise<MatchRate> {
    const response: AxiosResponse = await NestAPI.get(
      `businesses/${businessID}/funnel/historical-match-rate/${eventType}`
    )

    return response.data
  }

  async getFBConnectedAccounts(
    fbAccountID: string,
    businessID?: number,
    adAuthorizerID?: number
  ): Promise<BusinessFBObjects> {
    const response: BusinessFBObjects = await NestAPI.get(`businesses/manage/fb-objects`, {
      params: {
        fb_account_id: fbAccountID,
        business_id: businessID,
        fb_ad_authorizer_id: adAuthorizerID,
      },
    })

    return response
  }

  async resolveIssueWithBusiness(businessID: number, flag: BusinessError): Promise<boolean> {
    return await NestAPI.patch(`businesses/manage/${businessID}/remove-flag`, {
      flag,
    })
  }

  async getFBBusinesses(): Promise<FBBusiness[]> {
    const response: FBBusiness[] = await NestAPI.get(`businesses/manage/fb-businesses`)

    return response
  }

  async getFBPages(): Promise<FBBusinessPage[]> {
    const response: FBBusinessPage[] = await NestAPI.get(`businesses/manage/fb-pages`)

    return response
  }

  async getFBAdAccounts(): Promise<FBBusinessAdAccount[]> {
    const response: FBBusinessAdAccount[] = await NestAPI.get(`businesses/manage/fb-ad-accounts`)

    return response
  }

  async getFBDatasets(fbAccountID: string): Promise<FacebookPixel[]> {
    const response: FacebookPixel[] = await NestAPI.get(`businesses/manage/fb-datasets`, {
      params: {
        fb_account_id: fbAccountID,
      },
    })

    return response
  }

  async getFBIGAccounts(fbAccountID: string): Promise<FBBusinessIGAccount[]> {
    const response: FBBusinessIGAccount[] = await NestAPI.get(`businesses/manage/fb-ig-accounts`, {
      params: {
        fb_account_id: fbAccountID,
      },
    })

    return response
  }

  async verifyFBConnection(
    verify: MMFacebookVerificationFields
  ): Promise<SystemUserIDs & FacebookAssetNames> {
    return await NestAPI.post(`businesses/manage/fb-verify`, verify)
  }

  async clearFacebookAccessCache() {
    await NestAPI.post(`businesses/manage/clear-fb-access-cache`)
  }
}
